/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'
import { OptionProps } from 'react-crane'

import { secondaryTextColor } from '../../../lib/styles/colors'
import { formatCredits } from '../../../lib/utils'
import { PlanItemOption } from '../../../types'

const optionWrapperCss = css`
  display: flex;
  justify-content: space-between;
`

const creditsCss = css`
  color: ${secondaryTextColor};
  padding-left: 6px;
  white-space: nowrap;
`

export const CourseOptionLabel = ({ getOptionLabel, labelKey, option, selected }: OptionProps) => {
  const planItemOption = option as PlanItemOption

  if (!planItemOption) {
    return null
  }

  if (planItemOption.uniqueKey === 'ADD_ITEM_OPTION') {
    return <span>{getOptionLabel({ labelKey, option, selected })}</span>
  }

  const { label, creditsMin, creditsMax } = planItemOption
  const formattedCredits = formatCredits(creditsMin, creditsMax)

  return (
    <div css={optionWrapperCss}>
      <span>{label}</span> {formattedCredits && <span css={creditsCss}>{formattedCredits}</span>}
    </div>
  )
}

export default CourseOptionLabel
